module.exports = __webpack_public_path__ + "img/usa-flag.6d2d811f.jpeg";